/**
 * LocalStorage Utils - Set/Get Data with expiry times.
 */

// Set a value in local storage
export const setLocalStorageValue = (key, value, expires = 0) => {
  const externalValues = getFinalValues(key, value);

  // Create an object containing the value and expiration time
  const obj = {
    value: externalValues,
    expires: expires,
  };

  // Store the object in local storage
  localStorage.setItem(key, JSON.stringify(obj));
};

const getFinalValues = (key, value) => {
  let newValues = {};

  if (typeof value === "string") {
    newValues = value;
  } else {
    const previousValue = getLocalStorageValue(key);

    // temp code for already existing cart identifier key in localStorage
    if (typeof previousValue === "string") {
      newValues = { id: previousValue, ...value };
    } else {
      newValues = { ...previousValue, ...value };
    }
  }

  return newValues;
};

// Get Expiry value from local storage
export const getExpiryFromStorage = (key) => {
  const storedObj = localStorage.getItem(key);

  try {
    // Parse the stored object
    const parsedObj = JSON.parse(storedObj);


    // Check if the stored object exists and has not expired
    if (parsedObj && (parsedObj.expires > new Date().getTime() || parsedObj.expires == 0) ) {
      return parsedObj.expires; // Return the value
    } else {
      localStorage.removeItem(key); // Remove the expired value from local storage
      return null; // Return null if value does not exist or expired
    }
  } catch (e) {
    // Handle expection and return null;
    return null;
  }
};

// Get a value from local storage
export const getLocalStorageValue = (key) => {
  // Retrieve the stored object
  const storedObj = localStorage.getItem(key);

  try {
    // Parse the stored object
    const parsedObj = JSON.parse(storedObj);

    // Check if the stored object exists and has not expired
    if ( parsedObj && (parsedObj.expires > new Date().getTime() || parsedObj.expires == 0) ) {
      return parsedObj.value; // Return the value
    } else {
      localStorage.removeItem(key); // Remove the expired value from local storage
      return null; // Return null if value does not exist or expired
    }
  } catch (e) {
    // Handle expection and return null;
    return null;
  }
};

// Remove a value from local storage
export const removeLocalStorageValue = (key) => {
  localStorage.removeItem(key);
};
